import React from 'react';
import { $Badge } from './styles';
export const Badge = ({ children, color, fullWidth }) => {
    return (React.createElement($Badge, { color: color, fullWidth: fullWidth }, children));
};
